// Colors/fonts approximate Highlands Coffee's public brand identity (signature red + cream,
// bold rounded wordmark) - not sourced from an official brand guideline. Swap for exact
// values if a logo/brand asset becomes available.
export const UME_COLORS = {
    promoter: "#0ca30c",
    passive: "#7d7d7d",
    detractor: "#d03b3b",
    y2025: "#9c9086",
    y2026: "#c8102e",
    magnitude: "#c8102e",
    ink: "#2b1b12",
    mutedInk: "#8a7368",
    cream: "#f7f1e3",
    surface: "#ffffff"
};

export const UME_FONTS = {
    heading: "'Fredoka', 'Roboto', sans-serif",
    body: "'Roboto', sans-serif"
};
